// AJAX product variant handling for Shopify forms
document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('.product-form');
  if (!productForm) return;

  const variantIdInput = productForm.querySelector('#product-variant-id');
  const priceElement = document.querySelector('#product-price');
  const submitButton = productForm.querySelector('button[type="submit"]');
  const buttonText = submitButton.querySelector('.product-form-cart-text');
  
  // Create loading spinner element (positioned absolutely to avoid layout shift)
  const loadingSpinner = document.createElement('div');
  loadingSpinner.className = 'loading-spinner absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-200';
  loadingSpinner.innerHTML = `
    <svg class="animate-spin h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  `;
  
  // Make sure the button has relative positioning for absolute spinner
  if (submitButton) {
    submitButton.style.position = 'relative';
    submitButton.appendChild(loadingSpinner);
  }
  
  // Get product data from the page
  const optionSelectors = productForm.querySelectorAll('input[type="radio"]');
  
  function findVariant(optionValues) {
    if (!window.productVariants) return null;
    
    return window.productVariants.find(variant => {
      return optionValues.every((value, index) => {
        const variantOption = variant[`option${index + 1}`];
        return !value || variantOption === value;
      });
    });
  }
  
  function getSelectedOptions() {
    const options = [];
    const fieldsets = productForm.querySelectorAll('fieldset');
    
    fieldsets.forEach(fieldset => {
      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      options.push(checkedInput ? checkedInput.value : null);
    });
    
    return options;
  }
  
  function updateVariant() {
    const selectedOptions = getSelectedOptions();
    const variant = findVariant(selectedOptions);
    
    // Update visual state for all variant options
    updateVariantVisualState();
    
    if (variant) {
      // Update hidden input
      variantIdInput.value = variant.id;
      
      // Update price
      if (priceElement) {
        priceElement.textContent = formatMoney(variant.price);
      }
      
      // Update button
      if (submitButton && buttonText) {
        submitButton.disabled = !variant.available;
        
        if (variant.available) {
          buttonText.textContent = `Add to cart`;
          submitButton.classList.remove('disabled:bg-gray-400', 'disabled:cursor-not-allowed');
          submitButton.classList.add('bg-primary', 'hover:bg-primary/90');
        } else {
          buttonText.textContent = 'Sold out';
          submitButton.classList.add('disabled:bg-gray-400', 'disabled:cursor-not-allowed');
          submitButton.classList.remove('bg-primary', 'hover:bg-primary/90');
        }
      }
      
      // Update URL with variant parameter
      updateURLWithVariant(variant);
    }
  }
  
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(undefined, { 
        style: 'currency', 
        currency: window.shopCurrency || 'USD' 
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  
  function updateVariantVisualState() {
    // Update all variant option labels to show selected state
    const allVariantLabels = productForm.querySelectorAll('.variant-option');
    const checkedInputs = productForm.querySelectorAll('input[type="radio"]:checked');
    
    // Reset all labels
    allVariantLabels.forEach(label => {
      label.removeAttribute('data-selected');
      label.classList.remove('border-primary', 'bg-primary', 'text-white');
      label.classList.add('border-gray-300', 'bg-white', 'text-gray-900');
    });
    
    // Set selected state for checked inputs
    checkedInputs.forEach(input => {
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (label) {
        label.setAttribute('data-selected', 'true');
        label.classList.remove('border-gray-300', 'bg-white', 'text-gray-900');
        label.classList.add('border-primary', 'bg-primary', 'text-white');
      }
    });
  }
  
  function updateURLWithVariant(variant) {
    if (!variant || !history.replaceState) return;
    
    try {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url.toString());
    } catch (e) {
      // Fallback for older browsers
      console.warn('Could not update URL with variant:', e);
    }
  }
  
  // Loading state management
  function setLoadingState(isLoading) {
    if (isLoading) {
      submitButton.disabled = true;
      buttonText.style.opacity = '0';
      loadingSpinner.style.opacity = '1';
      submitButton.classList.add('cursor-not-allowed');
    } else {
      submitButton.disabled = false;
      buttonText.style.opacity = '1';
      loadingSpinner.style.opacity = '0';
      submitButton.classList.remove('cursor-not-allowed');
    }
  }
  
  // Show success feedback
  function showSuccessMessage() {
    const originalText = buttonText.textContent;
    buttonText.textContent = 'Added ✓';
    
    setTimeout(() => {
      buttonText.textContent = originalText;
    }, 1500);
  }
  
  // Show error feedback
  function showErrorMessage(message = 'Try again') {
    const originalText = buttonText.textContent;
    buttonText.textContent = message;
    buttonText.style.opacity = '0.7';
    
    setTimeout(() => {
      buttonText.textContent = originalText;
      buttonText.style.opacity = '1';
    }, 2500);
  }
  
  // AJAX add to cart function
  async function addToCart(formData) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: formData.get('id'),
          quantity: parseInt(formData.get('quantity')) || 1
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      return result;
    } catch (error) {
      throw error;
    }
  }
  
  // Listen for variant changes
  optionSelectors.forEach(input => {
    input.addEventListener('change', updateVariant);
  });
  
  // Handle form submission with AJAX
  productForm.addEventListener('submit', async function(e) {
    e.preventDefault();
    
    // Don't allow submission if no variant is selected or if already loading
    if (!variantIdInput.value || submitButton.disabled) {
      return;
    }
    
    const formData = new FormData(productForm);
    
    // Set loading state
    setLoadingState(true);
    
    try {
      await addToCart(formData);
      
      // Show success feedback
      showSuccessMessage();
      
      // Update cart count if cart drawer/counter exists
      updateCartCount();
      
    } catch (error) {
      console.error('Add to cart error:', error);
      
      // Handle specific Shopify errors with minimal messages
      let errorMessage = 'Try again';
      if (error.message.includes('404')) {
        errorMessage = 'Not found';
      } else if (error.message.includes('422')) {
        errorMessage = 'Invalid';
      }
      
      showErrorMessage(errorMessage);
    } finally {
      // Always reset loading state
      setLoadingState(false);
    }
  });
  
  // Update cart count function (optional - updates cart counter if it exists)
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
          element.setAttribute('data-cart-count', cart.item_count);
        });
      })
      .catch(error => {
        console.warn('Could not update cart count:', error);
      });
  }
  
  // Handle URL variant parameter on page load
  function initializeFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if (variantId && window.productVariants) {
      const variant = window.productVariants.find(v => v.id == variantId);
      if (variant) {
        // Set the correct radio buttons for this variant
        const fieldsets = productForm.querySelectorAll('fieldset');
        fieldsets.forEach((fieldset, index) => {
          const optionValue = variant[`option${index + 1}`];
          if (optionValue) {
            const radioInput = fieldset.querySelector(`input[value="${optionValue}"]`);
            if (radioInput) {
              radioInput.checked = true;
            }
          }
        });
      }
    }
  }
  
  // Initialize from URL first, then update variant
  initializeFromURL();
  updateVariant();
});
